const validate = values => {
    const errors = {};
    if (!values.CodigoCabys) {
      errors.CodigoCabys = 'Requerido';
    }
    if (!values.Codigo) {
      errors.Codigo = 'Requerido';
    }
    if (!values.Descripcion) {
      errors.Descripcion = 'Requerido';
    }
    if (!values.PrecioUnitario) {
      errors.PrecioUnitario = 'Requerido';
    }
    if(!values.TarifaImpuesto ){
      errors.TarifaImpuesto = 'Requerido';
    }
    
    return errors;
  };
  
  export default validate;
  